import { useEffect, useState } from 'react'
import { api } from '../api'
import { Card, Spin, Space, Typography, Row, Col, Tag, Progress, Statistic, Empty } from 'antd'
import { EuroOutlined, ExperimentOutlined, CalendarOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

export default function Costes() {
  const [datos, setDatos] = useState(null)
  const [cargando, setCargando] = useState(true)

  useEffect(() => {
    api('/costes/resumen')
      .then(d => setDatos(d))
      .catch(err => console.error('Error cargando costes:', err))
      .finally(() => setCargando(false))
  }, [])

  if (cargando) return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <div style={{ background: 'linear-gradient(135deg, #1B3A6B 0%, #2E5FA3 100%)', padding: '20px' }}>
        <Title level={4} style={{ color: 'white', margin: 0 }}>Costes</Title>
      </div>
      <div style={{ textAlign: 'center', marginTop: '60px' }}><Spin size="large" /></div>
    </div>
  )

  if (!datos) return null

  const maxCultivo = Math.max(...datos.por_cultivo.map(c => parseFloat(c.total_coste) || 0), 1)
  const maxTipo = Math.max(...datos.por_tipo.map(t => parseFloat(t.total) || 0), 1)
  const maxMes = Math.max(...datos.por_mes.map(m => parseFloat(m.total) || 0), 1)

  const meses = { '01': 'Ene', '02': 'Feb', '03': 'Mar', '04': 'Abr', '05': 'May', '06': 'Jun', '07': 'Jul', '08': 'Ago', '09': 'Sep', '10': 'Oct', '11': 'Nov', '12': 'Dic' }

  return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <div style={{ background: 'linear-gradient(135deg, #1B3A6B 0%, #2E5FA3 100%)', padding: '20px' }}>
        <Title level={4} style={{ color: 'white', margin: 0 }}>Costes</Title>
      </div>

      <div style={{ padding: '16px' }}>
        {/* Total */}
        <Card size="small" style={{ borderRadius: '12px', marginBottom: '16px', textAlign: 'center' }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Coste total</Text>
          <Title level={2} style={{ margin: 0, color: '#E65100' }}>
            {datos.total.toFixed(2)} €
          </Title>
        </Card>

        {/* Por cultivo */}
        <Card size="small" title={<Text strong style={{ fontSize: '14px' }}><ExperimentOutlined /> Por cultivo</Text>} style={{ borderRadius: '12px', marginBottom: '16px' }}>
          {datos.por_cultivo.length === 0 ? (
            <Text type="secondary" style={{ fontSize: '12px' }}>Sin datos</Text>
          ) : (
            <Space direction="vertical" size={10} style={{ width: '100%' }}>
              {datos.por_cultivo.map(c => {
                const total = parseFloat(c.total_coste) || 0
                return (
                  <div key={c.id}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                      <div>
                        <Text strong style={{ fontSize: '13px', color: '#1B3A6B' }}>{c.nombre}</Text>
                        <Text type="secondary" style={{ fontSize: '11px', marginLeft: '6px' }}>{c.tipo_cultivo}</Text>
                        {c.estado === 'finalizado' && <Tag color="success" style={{ fontSize: '10px', marginLeft: '4px' }}>Fin</Tag>}
                      </div>
                      <Text strong style={{ fontSize: '14px', color: '#E65100' }}>{total.toFixed(2)} €</Text>
                    </div>
                    <Progress
                      percent={Math.round((total / maxCultivo) * 100)}
                      showInfo={false}
                      strokeColor="#E65100"
                      size="small"
                    />
                    <Text type="secondary" style={{ fontSize: '11px' }}>{c.num_acciones} acciones</Text>
                  </div>
                )
              })}
            </Space>
          )}
        </Card>

        {/* Por tipo de acción */}
        <Card size="small" title={<Text strong style={{ fontSize: '14px' }}><EuroOutlined /> Por tipo de acción</Text>} style={{ borderRadius: '12px', marginBottom: '16px' }}>
          {datos.por_tipo.length === 0 ? (
            <Text type="secondary" style={{ fontSize: '12px' }}>Sin datos</Text>
          ) : (
            <Space direction="vertical" size={8} style={{ width: '100%' }}>
              {datos.por_tipo.map((t, i) => {
                const total = parseFloat(t.total) || 0
                return (
                  <div key={i}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2px' }}>
                      <Text style={{ fontSize: '13px' }}>{t.tipo}</Text>
                      <Text strong style={{ fontSize: '13px', color: '#E65100' }}>{total.toFixed(2)} €</Text>
                    </div>
                    <Progress
                      percent={Math.round((total / maxTipo) * 100)}
                      showInfo={false}
                      strokeColor="#1890ff"
                      size="small"
                    />
                  </div>
                )
              })}
            </Space>
          )}
        </Card>

        {/* Por mes */}
        <Card size="small" title={<Text strong style={{ fontSize: '14px' }}><CalendarOutlined /> Por mes</Text>} style={{ borderRadius: '12px' }}>
          {datos.por_mes.length === 0 ? (
            <Text type="secondary" style={{ fontSize: '12px' }}>Sin datos</Text>
          ) : (
            <Space direction="vertical" size={6} style={{ width: '100%' }}>
              {datos.por_mes.map((m, i) => {
                const total = parseFloat(m.total) || 0
                const [year, month] = m.mes.split('-')
                return (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Text style={{ fontSize: '12px', width: '70px', color: '#666' }}>{meses[month]} {year}</Text>
                    <div style={{ flex: 1 }}>
                      <div style={{
                        height: '20px',
                        width: `${Math.max((total / maxMes) * 100, 2)}%`,
                        background: 'linear-gradient(90deg, #1B3A6B, #2E5FA3)',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        paddingRight: '6px',
                        minWidth: '50px',
                      }}>
                        <Text style={{ fontSize: '11px', color: 'white', fontWeight: 'bold' }}>{total.toFixed(0)} €</Text>
                      </div>
                    </div>
                  </div>
                )
              })}
            </Space>
          )}
        </Card>
      </div>
    </div>
  )
}
